import { render } from "./SectionPickup.vue?vue&type=template&id=7d733c96&scoped=true"
import script from "./SectionPickup.vue?vue&type=script&lang=js"
export * from "./SectionPickup.vue?vue&type=script&lang=js"

import "./SectionPickup.vue?vue&type=style&index=0&id=7d733c96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d733c96"]])

export default __exports__